module.exports = __webpack_public_path__ + "img/visa.6349bd0e.svg";